import { z } from 'zod';
import { idArray } from './shared.schema';

export const signUpTerminationParametersSchema = z
	.strictObject({
		startDate: z.iso.date().optional(),
		endDate: z.iso.date().optional(),
		areaIds: idArray.optional(),
		branchIds: idArray.optional(),
		districtIds: idArray.optional(),
		facilityIds: z.array(z.string()).optional(),
	})
	.superRefine((value, ctx) => {
		if (value.endDate && !value.startDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['endDate'],
				message: 'Cannot specify endDate without startDate',
			});
		}

		if (value.startDate && value.endDate && value.endDate < value.startDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['endDate'],
				message: 'End date must be on or after start date',
			});
		}
	});

export type SignUpTerminationParameters = z.infer<typeof signUpTerminationParametersSchema>;
